<script setup>
import { addIcon, deleteIcon, draggableIcon } from '../../utils/icons'
import { useTestStore } from '../../stores/TestStore';
import { useDraggable } from '../../composables/draggable.js'

const testStore = useTestStore();

const { draggedItem, dragOverItem, handleDragStart, handleDragOver, handleDragReset, handleDragEnd } = useDraggable();

function handleDrop(index) {
  testStore.aux_cambia_posicion(testStore.secciones, draggedItem.value, index)
  handleDragReset()
}

// Si la seción tiene preguntas, o respuestas o leyendas, no puedo borrarla
function puedo_borrar_seccion(seccion_id) {
  if(testStore.preguntas_seccion(seccion_id).length > 0) return false;
  if(testStore.respuestas_seccion(seccion_id).length > 0) return false;
  if(testStore.leyendas_seccion(seccion_id).length > 0) return false;
  return true;
}

</script>

<template>

  <div class="secciones-test my-5">

    <div class="flex justify-between border-b-2 mb-5 pb-2">
      <h5 class="font-bold text-blue-700">Secciones</h5>
      <button class="button-text-icon-sm" type="button" @click="testStore.add_seccion">
        <i v-html='addIcon'></i><span class="mx-2">Añadir</span>
      </button>
    </div>

    <div class="mb-1" >
      <div class="flex flex-row space-x-4 font-bold mb-2">
        <div class="w-1/4">Nombre</div> 
        <div class="w-2/4">Descripción</div>
        <div class="w-2/12">Dimensión</div>
        <div class="w-12"></div>
        <div class="w-12"></div>
      </div>
    </div>

    <div class="sortable-list">
      <div 
        v-for="(seccion, index) in testStore.secciones" :key="seccion.id" 
        class="seccion-test mb-1 p-0 flex flex-row space-x-4"
        :draggable="true"
        @dragstart="handleDragStart(index)"
        @dragover="handleDragOver($event, index)"
        @drop="handleDrop(index)"
        @dragend="handleDragEnd"
        :class="{ 'bg-blue-200': index === draggedItem, 'border-2 border-dashed border-blue-200': index == dragOverItem && index != draggedItem }"
        >
        <div class="basis-1/4"><input class="input-f" v-model="seccion.nombre" type="text" placeholder="Nombre"></div>
        <div class="basis-2/4"><textarea class="textarea-f h-10" v-model="seccion.descripcion" placeholder="Descripción ..."></textarea></div>
        
        <div class="w-2/12">
          <select v-model="seccion.dimension_id" class="select-f">
            <option :value="null">---</option>
            <option v-for="dimension in testStore.dimensiones" :value="dimension.id" :key="dimension.id">{{ dimension.nombre }}</option>
          </select>
        </div>
        
        <div class="w-12" >
          <span class="button-icon-out-gray-red" type="button" @click="testStore.delete_seccion(seccion.id)" v-if="puedo_borrar_seccion(seccion.id)">
            <i v-html='deleteIcon'></i>
          </span>    
        </div>

        <div class="w-12">
          <span class="button-icon-out-gray-blue" type="button"><i v-html='draggableIcon'></i></span>    
        </div>

      </div>
    </div>

  </div>

</template>

<style lang="scss">

</style>
